import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  }

  body {
    background-color: #0b0f19;
    color: #f8fafc;
    min-height: 100vh;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    line-height: 1.5;
  }

  /* Custom Scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #0b0f19;
  }

  ::-webkit-scrollbar-thumb {
    background: #1f2937;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #374151;
  }

  /* Selection Style */
  ::selection {
    background-color: #6366f1;
    color: #ffffff;
  }

  /* Smooth scroll behavior */
  html {
    scroll-behavior: smooth;
  }

  /* Helper utilities if needed */
  a {
    color: inherit;
    text-decoration: none;
  }
`;

export default GlobalStyle;
